import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ApplicationOptionsContextProvider } from './ContextProviders/ApplicationOptionsContextProvider';

ReactDOM.render(
  <React.StrictMode>
    <ApplicationOptionsContextProvider>
    <App />
    </ApplicationOptionsContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
